export const sanitize = (obj: any) => {
	return JSON.parse(
		JSON.stringify(obj, (key, value) => {
			return value === null ? undefined : value;
		}),
	);
};

export const sanitizeWithNull = (data: any) =>
	JSON.parse(
		JSON.stringify(data, (key, value) =>
			value === '' || value === null ? undefined : value,
		),
	);
